import axios from 'axios';
import axiosRetry from 'axios-retry';
import globalvariable from  '../global_variable';
//import store from '../store';
//import router from '../router';
//import { localStorages } from '../api/storage/localStorage'
export function fetch(params,baseURL){
	console.log(params);
  return new Promise((resolve,reject)=>{
    let headers = Object.assign({'Content-Type': 'text/plain;charset=UTF-8'},params.headers);
      const  instance = axios.create({
         baseURL:baseURL || globalvariable.requestUrl,
         headers:headers,
         timeout: 30000 // 超时
       });
     axiosRetry(instance, { retries: 2, retryCondition: (error)=>{
        //true为打开自动发送请求，false为关闭自动发送请求
        //这里的意思是当请求方式为get时打开自动发送请求功能
        console.log(error);
        return (error.config.method === 'get' || error.config.method === 'post');
     }});
    instance(params.options).then(response=>{
         const  res = response;
         resolve(res);
         console.log(res)
       }).catch(err=>{
           //发生异常错误,请刷新页面重试,或联系程序员
         //提示
         
         console.log(err)
          reject(err);
        // errInfo(err);
       });

  })
}
export function fetchJson(params){
  return new Promise((resolve,reject)=>{
    let uid = store.state.user.uid ||  router.apps[0].$route.query.uid;
    let accessToken  = store.state.user.accesstoken || localStorages.get(`accesstoken_${uid}`);
    let headers = Object.assign({'accessToken':accessToken,'Content-Type': 'application/json'},params.headers);
    const  instance = axios.create({
      headers: headers,  //用来验证是否登录
      baseURL:globalvariable.requestUrl,
      timeout: 30000
    });
    axiosRetry(instance, { retries: 3, retryCondition: (error)=>{
        //true为打开自动发送请求，false为关闭自动发送请求
        //这里的意思是当请求方式为get时打开自动发送请求功能
        console.log(error);
        return (error.config.method === 'get' || error.config.method === 'post');
    }})
    instance(params.options).then(response=>{
      const  res = response;
      resolve(res);
    }).catch(err=>{
      reject(err);
     // errInfo(err);
    });

  })
}
export function fetchSessionJson(params){
    return new Promise((resolve,reject)=>{
         // let uid = store.state.user.uid ||  router.apps[0].$route.query.uid;
         let sessionToken  = store.state.user.sessionToken;
         let headers = Object.assign({'sessionToken':sessionToken,'Content-Type': 'application/json'},params.headers);
         const  instance = axios.create({
            headers: headers,  //用来验证是否登录
            baseURL:globalvariable.requestUrl,
            timeout: 30000
        });
       axiosRetry(instance,
        { retries: 3, retryCondition: (error)=>{
            //true为打开自动发送请求，false为关闭自动发送请求
            //这里的意思是当请求方式为get时打开自动发送请求功能
            console.log(error);
            return (error.config.method === 'get' || error.config.method === 'post');
          }})
        instance(params.options).then(response=>{
            const  res = response;
            resolve(res);
        }).catch(err=>{
          console.log(err);
          reject(err);
            // errInfo(err);
        });

    })
}
